<template>
    <div>
        <!-- LISTE DES ENERGIES -->
        <div v-for="(ex, index) in Values" :key="index">
            <div v-if="ex in expendables" >
                <b-img :src="expendables[ex].path"/>
                <font-awesome-icon :icon="expendables[ex].direction"/>
            </div>
            <b-badge v-else variant="warning">
                Aucune énergie
            </b-badge>
        </div>
    </div>
</template>

<script lang="ts">

/**
 * Composant utilitaire récupération images et icônes
 */
import { LinkUtils } from '@/components/commons/Utils';

/**
 * Composant Vue
 */
import {Component, Prop} from 'vue-property-decorator';

@Component
/**
 * Composant d'affichage des energies d'un compteur
 */
export default class ExpendableCell extends LinkUtils {
    
    /** Valeurs */
    @Prop({ default: () => [] })
    public Values!: string[];

    /**
     * Liste des energies et des éléments de représentation dans la liste des compteurs
     */
    private expendables: { [key: string] : { path: string, direction: string, title: string}} = {
        "1": { path: this.AbsoluteLink('Icons/Equipment_ElectricMeter_Icon.svg'), direction:"fa-solid fa-arrow-down", title:"Soutirage" },
        "2": { path: this.AbsoluteLink('Icons/Expendable_Wind_Turbine.svg'), direction:"fa-solid fa-arrow-up", title:"Injection"},
        "3": { path: this.AbsoluteLink('Icons/Equipment_SolarThermal_Icon.svg'), direction:"fa-solid fa-arrow-up", title:"Injection"},
        "4": { path: this.AbsoluteLink('Icons/Equipment_GasMeter_Icon.svg'), direction:"fa-solid fa-arrow-down", title:"Soutirage"}
    };
}
</script>
<style scoped>

</style>